export const BANK_ACCOUNTS_PATH = '/bank-accounts'
